import { render, staticRenderFns } from "./user-dasboard.component.vue?vue&type=template&id=7c491ec8"
import script from "./user-dasboard.component.ts?vue&type=script&lang=ts&external"
export * from "./user-dasboard.component.ts?vue&type=script&lang=ts&external"
import style0 from "./user-dasboard.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports